var browser = {
  versions: (function() {
    var u = navigator.userAgent,
      app = navigator.appVersion
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      iosVersion:
        parseFloat(
          ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(u) || [0, ''])[1])
            .replace('undefined', '3_2')
            .replace('_', '.')
            .replace('_', '')
        ) || false,
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == ' qq', //是否QQ
      uc: u.indexOf('UCBrowser') > -1,
      isTuJia: u.toLocaleLowerCase().indexOf('tujia') > -1,
      isMaYi: u.indexOf('mayi') > -1,
      isZFBMiniProgram: (/aliapp/.test(u.toLowerCase()) && /miniprogram/.test(u.toLowerCase())) || /alipayide/.test(u.toLowerCase()) // 支付宝环境
    }
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

export default browser
